<template>
  <div class="business-potential bg--color-10">
    <div class="container-wrapper bg--color-02">
      <div class="business-potential__container container-new">
        <span class="txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold txt--center--m">
          {{ $t('business.potential.title') }}
        </span>

        <span class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-04 txt--center--m">
          {{ $t('business.potential.description') }}
        </span>

        <div class="business-potential__items mt-24 mt-32--m">
          <div
            v-for="(item, index) in items"
            :key="index"
            :class="item.class"
            class="business-potential__item bg--color-01"
          >
            <span class="txt txt--26px txt--height-34px txt--color-04 txt--bold">
              {{ item.title }}
            </span>

            <span class="txt txt--22px txt--height-30px txt--color-04">
              {{ item.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    items () {
      return [
        { class: 'star first-star' },
        {},
        { class: 'star latest-star' },
      ].map((item, index) => {
        return {
          ...item,
          title: this.$t(`business.potential.items.${index}.title`),
          text: this.$t(`business.potential.items.${index}.text`),
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.business-potential {
  &__container {
    display: flex;
    flex-direction: column;
    gap: toRem(24px);
  }

  &__items {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(12px);

    @include bp(m) {
      grid-template-columns: repeat(3, 1fr);
      gap: toRem(24px);
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: toRem(12px);
    padding: toRem(24px);
    border: 1px solid rgba(28, 29, 32, 1);
    border-radius: toRem(16px);
    position: relative;
  }

  .star::before {
    content: '';
    position: absolute;
    background: url('@/assets/img/business/potential/start.svg');
    background-position: top;
    background-repeat: no-repeat;
    background-size: 28px;
    width: toRem(28px);
    height: toRem(62px);
    display: block;
  }

  .first-star::before {
    left: toRem(-15px);
    bottom: 10%;

    @include bp(m) {
      left: unset;
      right: 10%;
      bottom: toRem(-36px);
    }
  }

  .latest-star::before {
    right: toRem(-15px);
    bottom: toRem(14%);

    @include bp(m) {
      bottom: unset;
      right: 10%;
      top: toRem(-36px);
    }
  }
}
</style>
